export class UpdateClientUserRoleRequest {
    id: number; //clientUserClientId
    newStatus: boolean;
    roleName: string;

    constructor() {}
}